import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type FormData} from './form';

const domain = 'ACCOUNT_DETAILS';

export const {
    action: fetchDetails,
    success: fetchDetailsSuccess,
    failed: fetchDetailsFailed,
} = createAction(`${domain}/FETCH_ACCOUNT`, () => ({}));

export const {
    action: updateDetails,
    success: updateDetailsSuccess,
    failed: updateDetailsFailed,
} = createAction(
    `${domain}/UPDATE_DETAILS`,
    (data: FormData, languageUpdated: boolean) => ({data, languageUpdated}),
    (response: any) => ({response}),
);
